import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PreloadService } from './services/preload.service';
import { NavigationVisibilityService, VisibilityConfig } from './services/navigation-visibility.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit, OnDestroy {
    location: any;
    routerSubscription: any;
    showNavbarAndFooter: boolean = true;
    showNavbar: boolean = true;
    showFooter: boolean = true;
    showPreloader: boolean = false;
    private isFirstLoad: boolean = true;
    private destroy$ = new Subject<void>();

    constructor(
        private router: Router, 
        private preloadService: PreloadService,
        private navigationVisibilityService: NavigationVisibilityService
    ) {}

    async ngOnInit(){
        // Precargar recursos críticos en paralelo
        this.preloadService.preloadCriticalResources().catch(error => {
            console.warn('Error precargando recursos críticos:', error);
        });

        // Suscribirse a cambios de visibilidad
        this.navigationVisibilityService.visibility$
            .pipe(takeUntil(this.destroy$))
            .subscribe((config: VisibilityConfig) => {
                this.showNavbar = config.showNavbar;
                this.showFooter = config.showFooter;
                this.showNavbarAndFooter = config.showNavbar;
            });

        // Mostrar preloader solo en la carga inicial de la página principal
        const currentRoute = this.router.url;
        const isMainPage = currentRoute === '/' || currentRoute === '' || currentRoute === '/home';
        
        if (this.isFirstLoad && isMainPage) {
            this.showPreloader = true;
            // Ocultar el preloader después de un tiempo corto para mostrar el logo
            setTimeout(() => {
                this.showPreloader = false;
                this.isFirstLoad = false;
            }, 2000); // 2 segundos para mostrar el logo
        } else {
            // Si no es la página principal, no mostrar preloader
            this.showPreloader = false;
            this.isFirstLoad = false;
        }
        
        this.recallJsFuntions();
    }

    recallJsFuntions() {
        // Manejar transiciones elegantes solo para rutas de fase
        this.router.events
            .pipe(takeUntil(this.destroy$))
            .subscribe((event) => {
                if (event instanceof NavigationStart && !this.isFirstLoad) {
                    // Verificar si la ruta de destino es una fase
                    const isPhaseRoute = this.navigationVisibilityService.isPhaseRoute(event.url);
                    
                    if (isPhaseRoute) {
                        // Mostrar transición elegante al navegar a una fase
                        $('.page-transition').addClass('active');
                    }
                }
            });
        
        this.routerSubscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel),
                takeUntil(this.destroy$)
            )
            .subscribe(event => {
                $.getScript('../assets/js/main.js');
                this.location = this.router.url;
                
                // Ocultar transición al completar navegación (solo si fue una fase)
                if (!this.isFirstLoad && this.navigationVisibilityService.isPhaseRoute(this.location)) {
                    setTimeout(() => {
                        $('.page-transition').removeClass('active');
                    }, 600); // Tiempo suficiente para mostrar la info de la fase
                }
                
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}